
import { IXpathFieldMap } from "../../../models/configuration/xpathFieldMap/IXpathFieldMap";
import { Action, ActionType } from "../../actions";

interface XPathDataState {
  loading: boolean;
  error: string | null;
  data: IXpathFieldMap | null;
  persistedData: IXpathFieldMap | null;
}

const initialState = { loading: false, error: null, data: null, persistedData: null };

const cloneXPathConfig = (payload: IXpathFieldMap | null): IXpathFieldMap | null => {
  if (!payload) return payload;
  return JSON.parse(JSON.stringify(payload)) as IXpathFieldMap;
};

const xPathDataReducer = (
  state: XPathDataState = initialState,
  action: Action
): XPathDataState => {
  switch (action.type) {
    // GET DATA
    case ActionType.GET_CONFIG_XPATH_DATA:
      return { ...state, loading: true, error: null };
    case ActionType.GET_CONFIG_XPATH_DATA_FAILURE:
        return { ...state, loading: false, error: action.payload };
    case ActionType.GET_CONFIG_XPATH_DATA_SUCCESS: {
        const persistedData = action.fromServer ? cloneXPathConfig(action.payload) : state.persistedData;
        return { ...state, loading: false, error: null, data: action.payload, persistedData };
    }

    // SAVE DATA
    case ActionType.SAVE_CONFIG_XPATH_DATA:
      return { ...state, loading: true, error: null };
    case ActionType.SAVE_CONFIG_XPATH_DATA_FAILURE:
        return { ...state, loading: false, error: action.payload };
    case ActionType.SAVE_CONFIG_XPATH_DATA_SUCCESS:
        return { ...state, loading: false, error: null, data: action.payload, persistedData: cloneXPathConfig(action.payload) };

    case ActionType.CONFIG_ID_CHANGED:
        return initialState;
    default:
        return state;
  }
};

export default xPathDataReducer;